import React from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Informant from "../components/Informant/Informant";
import InformantPublic from "../components/InformantPublic/InformantPublic";
import PrivacyPolicy from "../common/PrivacyPolicy";
import Survey from "../components/Survey/Survey";

const AppRoutes = () => {
  return (
    <Routes>
        <Route exact path="/frontend" element={<Informant />} />
        <Route exact path="/privacy" element={<PrivacyPolicy />} />
        <Route exact path="/survey" element={<Survey />} />
        <Route exact path="/complaint" element={<Informant />} />
        <Route exact path="/complaint_public" element={<InformantPublic />} />
    </Routes>
  );
};

export default AppRoutes;
